'use client'

import tele from "@/public/image/etc/tele.svg";
import kakao from "@/public/image/etc/kakao.svg";
import { BannerContext, bannerTypes } from "@/context/bannerContext";
import { useContext, useEffect, useState } from "react";
import { useRouter } from "next/navigation";

export default function InqueryFooter() {
    const { site_banner } = useContext(BannerContext)
    const [bannerDomain, setBannerDomain] = useState<bannerTypes>()
    const [bannerKakao, setBannerKakao] = useState<bannerTypes>()
    const [bannerTele, setBannerTele] = useState<bannerTypes>()

    const router = useRouter()

    useEffect(() => {
        // console.log(site_banner)
        setBannerDomain(site_banner.find((el) => el.banner_type == 90 && el.image_url))
        setBannerKakao(site_banner.find((el) => el.banner_type == 91 && el.image_url))
        setBannerTele(site_banner.find((el) => el.banner_type == 92 && el.image_url))
    }, [site_banner])
    return (
        <footer className="inquery-footer">
            {
                bannerDomain
                && <img src={bannerDomain.image_url} alt="kakao" onClick={e=> router.push(bannerDomain.redirect_url)} />
            }
            {
                bannerKakao
                && <img src={bannerKakao.image_url} alt="kakao" onClick={e=> router.push(bannerKakao.redirect_url)} />
            }
            {
                bannerTele
                && <img src={bannerTele.image_url} alt="tele" onClick={e=> router.push(bannerTele.redirect_url)} />
            }
            {/* <div className="inquery-banner kakao">
                <img src={kakao.image_url} alt="kakao" />
                <p>카카오톡 문의 ID: {``}</p>
            </div>
            <div className="inquery-banner tele">
                <img src={tele.image_url} alt="tele" />
                <p>텔레그램 문의 ID: {``}</p>
            </div> */}
        </footer>
    )
}